import { render, staticRenderFns } from "./BulkSMS.vue?vue&type=template&id=86251432&scoped=true"
import script from "./BulkSMS.vue?vue&type=script&lang=ts"
export * from "./BulkSMS.vue?vue&type=script&lang=ts"
import style0 from "./BulkSMS.vue?vue&type=style&index=0&id=86251432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86251432",
  null
  
)

export default component.exports